import React from 'react';
import Main from 'layouts/Main';
import Container from 'components/Container';
import { MapHero } from '@akyga/shared-ui/MapHero';
import {
  Categories,
  SearchBoxHero,
  AboutUs,
  ContactLanding,
} from './components';
import Box from '@mui/material/Box';
import Timeline from './components/Timeline';
import OurMission from './components/OurMission';
import Bateryjki from './components/bateryjki';

const LandingPage = () => {
  return (
    <Main>
      <Box bgcolor={'alternate.main'} style={{ marginTop: '-7.5vh' }}>
        <SearchBoxHero />
      </Box>
      <Container>
        <Categories id="categories-section" />
      </Container>
      <Box>
        <Container id="about-us">
          <AboutUs />
        </Container>
      </Box>
      <Container
        sx={{
          display: {
            xs: 'none',
            sm: 'none',
            lg: 'block',
          },
        }}
      >
        <MapHero />
      </Container>
      <Container
        id="timeline-section"
        sx={{
          display: {
            xs: 'none',
            sm: 'none',
            lg: 'block',
          },
        }}
      >
        <Timeline />
      </Container>
      <Box bgcolor={'primary.main'}>
        <Container bgcolor={'primary.main'} id="timeline-section">
          <Bateryjki />
        </Container>
      </Box>
      <Container id="timeline-section">
        <OurMission />
      </Container>
      <Container
        id="contact-section"
        sx={{
          '@media (min-width: 900px)': {
            paddingBottom: '150px',
          },
        }}
      >
        <ContactLanding />
      </Container>
    </Main>
  );
};

export default LandingPage;
